import Vue from "vue";

// Check if number
Vue.prototype.isNumber = function(val) {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(val);
};

Vue.prototype.notify = function($message, $color = "is-dark", duration = 4000) {
    this.$buefy.toast.open({
        duration,
        message: $message,
        position: "is-top",
        type: $color
    });
};
